import React from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import i18next from 'i18next'

import ConfirmOrCancel from 'app/components/Modals/ConfirmOrCancel'
import StoriesListItem from './StoriesListItem'
import { modal } from 'store/entities/modal/actions'
import { deleteStoryApiRequest } from 'store/entities/feed/actions'
import FeedStoriesListItemMenuPopup from 'app/domains/common/FeedStoriesListItemMenuPopup'

const mapDispatchToProps = {
  showModal: modal.show,
  deleteStory: deleteStoryApiRequest,
  closeModal: modal.hide,
}

const mergeProps = (stateProps, { showModal, deleteStory, closeModal }, { activityUserStory, ...ownProps }) => {
  const { story, activity: { question }, id } = activityUserStory
  const initialValues = Map({ story, storyId: id })
  const handleDelete = () => {
    showModal(
      <ConfirmOrCancel
        confirmBtn={i18next.t('Delete')}
        title={i18next.t('user:Are you sure?')}
        text={i18next.t('user:Once you delete your story, it’s gone forever and you can’t add a new one')}
        handleSubmit={() => {
          deleteStory({ storyId: id })
          closeModal()
        }}
      />,
      { size: 'xs' }
    )
  }
  const handleEdit = () => {
    showModal(<FeedStoriesListItemMenuPopup question={question} initialValues={initialValues} />)
  }
  return {
    ...stateProps,
    ...ownProps,
    handleDelete,
    handleEdit,
    activityUserStory,
  }
}

export default connect(null, mapDispatchToProps, mergeProps)(StoriesListItem)
